import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from '@material-ui/pickers';
import { createMuiTheme } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import { ptBR } from 'date-fns/locale';

const CalendarInput = ({ date, changeDate }) => {
  const customMaterialTheme = createMuiTheme({
    palette: {
      text: {
        primary: '#5e6876',
      },
      primary: {
        main: '#F38D45',
      },
    },
  });

  return (
    <MuiThemeProvider theme={customMaterialTheme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
        <KeyboardDateTimePicker
          value={date}
          ampm={false}
          onChange={changeDate}
          className="sub-input"
          format="dd/MM/yyyy HH:mm"
          disableFuture={false}
        />
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>
  );
};

export default CalendarInput;
